import React from "react";
import moment from 'moment';
import PropTypes from 'prop-types';

export const DocumentDetailsSection = ({
    issuer,
    owner,
    holder,
    created,
    tokenRegistryVersion,
    tokenRegistryAddress
}) => {
    return (
        <>
            <div style={{ fontWeight: 800, fontSize: "12px", fontFamily: "Arial", marginBottom: "12px", color: "#14181E" }}>
                Document Details
            </div>
            <div style={{ display: "flex", fontFamily: "Arial", flexWrap: "wrap", gap: "3%", marginBottom: "12px" }}>
                <div style={{ width: "18%" }}>
                    <div style={{ fontWeight: 800, color: "#14181E", fontSize: "10px" }}>{"Issuer"}</div>
                    <div style={{ fontWeight: 500, color: "#60636B", fontSize: "10px", marginTop: "2px", overflowWrap: "break-word" }}>
                        {issuer}
                    </div>
                </div>
                <div style={{ width: "35%" }}>
                    <div style={{ fontWeight: 800, color: "#14181E", fontSize: "10px" }}>{"Owner"}</div>
                    <div style={{ fontWeight: 500, color: "#60636B", fontSize: "10px", marginTop: "2px", overflowWrap: "break-word" }}>
                        {owner}
                    </div>
                </div>
                <div style={{ width: "35%" }}>
                    <div style={{ fontWeight: 800, color: "#14181E", fontSize: "10px" }}>{"Holder"}</div>
                    <div style={{ fontWeight: 500, color: "#60636B", fontSize: "10px", marginTop: "2px", overflowWrap: "break-word" }}>
                        {holder}
                    </div>
                </div>
            </div>
            <div style={{ display: "flex", fontFamily: "Arial", flexWrap: "wrap", gap: "3%" }}>
                <div style={{ width: "18%" }}>
                    <div style={{ fontWeight: 800, color: "#14181E", fontSize: "10px" }}>{"Issued on"}</div>
                    <div style={{ fontWeight: 500, color: "#60636B", fontSize: "10px", marginTop: "2px" }}>{moment(created).format('MMMM Do, YYYY')}</div>
                </div>
                <div style={{ width: "35%" }}>
                    <div style={{ fontWeight: 800, color: "#14181E", fontSize: "10px" }}>{"Token Registry Version:"}</div>
                    <div style={{ fontWeight: 500, color: "#60636B", fontSize: "10px", marginTop: "2px" }}>{tokenRegistryVersion}</div>
                </div>
                <div style={{ width: "35%" }}>
                    <div style={{ fontWeight: 800, color: "#14181E", fontSize: "10px" }}>{"Token Registry Address:"}</div>
                    <div style={{ fontWeight: 500, color: "#60636B", fontSize: "10px", marginTop: "2px", overflowWrap: "break-word" }}>
                        {tokenRegistryAddress}
                    </div>
                </div>
            </div>
        </>
    );
};

DocumentDetailsSection.propTypes = {
    issuer: PropTypes.string,
    owner: PropTypes.string,
    holder: PropTypes.string,
    created: PropTypes.string,
    tokenRegistryVersion: PropTypes.string,
    tokenRegistryAddress: PropTypes.string
};